import React, { FC, useEffect, useState } from "react"
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";
import {
    SearchSelectWithIndeterminateBoolean
} from "../../../components/common/datatable/DataTableUtils";
import {
    useGetAllExternalStatesQuery, useLazyExportExternalBillReleasesQuery,
    useLazyGetAllExternalCountyByStateAbbrQuery,
    useSearchExternalBillReleasesQuery
} from "./externalApi";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { SearchSelectWithList } from "../../../components/common/datatable/filter/SearchSelectWrapper";
import { Link, useNavigate } from "react-router-dom";
// @ts-ignore
import defaultLogo from "../../../images/titleLogixLogo.png";

const ExternalBillReleases: FC = () => {

    const stateData = useGetAllExternalStatesQuery("");
    const [getAllCountyByStateAbbrApi, countyData] = useLazyGetAllExternalCountyByStateAbbrQuery()
    const navigate = useNavigate();
    const [tenantLogoUrl, setTenantLogoUrl] = useState("");
    const [triggerExportBillReleaseDataQuery] = useLazyExportExternalBillReleasesQuery();

    useEffect(() => {
        document.title = "Bill Releases";
    });

    const columns: DataTableColumn[] = [

        {
            label: "State", accessor: "county.state.stateName", visibility: { canColumnShow: false },
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateData?.data, "stateName", "stateAbbreviation", "Select State...", false, "state", null),
                overrideFilterAccessor: "state"
            }],
        },

        {
            label: "County", accessor: "county.countyName",
            cell: (props: any) => {
                return <>
                    <span>{props.row.original?.countyName + ", " + props.row.original?.stateAbbreviation}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(countyData?.data, "countyName", "id", "Select counties...", true, "countyIds"),
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
                overrideFilterLabel: "Counties",
                overrideFilterAccessor: "countyIds"
            }],
        },

        {
            label: "Tax Year", accessor: "taxYear",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Tax Year..."}
                    accessor={"taxYear"} />,
                overrideFilterLabel: "Tax Year",
                overrideFilterAccessor: "taxYear"
            }],
        },
        {
            label: "Is Released",
            accessor: "released",
            cell: (props: any) => <>
                {!!props.value ?
                    <i className="fa fa-check-circle enabled-data align--center enabled text-text-4" /> :
                    <i className="fa fa-times-circle disabled-data align--center enabled" aria-hidden="true" />
                }
            </>,
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Is Released...", "released"),
                overrideFilterAccessor: "released",
                overrideFilterLabel: "Is Released",
            }]
        },
        {
            label: "Note", accessor: "note",
            cell: (props: any) => {
                return <>
                    <div title={props.value} className="max-w-[200px]  whitespace-nowrap">
                        {props.value?.length > 70 ? props.value?.substring(0, 70) + "..." : props.value}
                    </div>
                </>
            },
        }
    ]

    return (
        <section className="flex flex-col min-h-[calc(100vh-24px)]">
            <header
                className="pr-5 pl-4 z-50 items-center sticky top-0 w-full header bg-surface-0 px-2 border-b-2 flex justify-between ">
                <div className="justify-between   flex items-center">
                    <Link to="/home" className="flex items-center space-x-2">
                        <img className={tenantLogoUrl == defaultLogo ? "blur-sm " : ""} height="28"
                            src={tenantLogoUrl || defaultLogo} alt="Company Logo" width={207} />
                    </Link>
                </div>
                <div className="right_nav items-center  sm:block md:block lg:flex gap-2">
                    <ul className={'header_links flex justify-end p-3 bg-surface-0 text-text-0 gap-2 mb-0'}>
                        <li>
                            <li className="flex">
                                <button
                                    className="items-center ml-3"
                                    onClick={() => {

                                        navigate("/login")
                                    }}>
                                    <i className="fas fa-sign-out-alt text-text-0 hover:text-highlight-7 text-lg"
                                        title="Log out" /> Login
                                </button>

                            </li>
                        </li>
                    </ul>
                </div>
            </header>
            <div className="relative">
                <div className="px-4 py-2 pt-12">
                    <DataTable
                        columns={columns}
                        actions={{
                            fetchAction: useSearchExternalBillReleasesQuery,
                            exportAction: triggerExportBillReleaseDataQuery
                        }}
                        defaultSortOptions={{
                            accessor: "county.countyName",
                            direction: "asc"
                        }}

                    />
                </div>
            </div>

        </section>
    )
}
export default ExternalBillReleases